import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-sample-card-corsi',
  templateUrl: './sample-card-corsi.component.html',
  styleUrls: ['./sample-card-corsi.component.scss']
})
export class SampleCardCorsiComponent implements OnInit {

  @Input() dataCorsi: any;
  @Input() isNews: boolean = false;
  public isHoverCard: boolean = false;
  public stringTaxonomies: string = '';
  public domainWebsite = environment.urlApi;
  public imgPath = '';
  public image_alt = '';
  public objTitle = {
    title: '',
    hreflang: '',
    link: ''
  };


  constructor(
    private helperService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    if (this.dataCorsi) {
      this.setVariable();
      this.setLabelTags();
    }
  }

  private setVariable() {
    if (this.dataCorsi) {
      this.objTitle = this.helperService.retriveLinkTagA(this.dataCorsi.field_titolo, "a");
      this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.dataCorsi.field_immagine, "src");
      this.image_alt = this.helperService.retrieveImage(this.dataCorsi.field_immagine, "alt");
      this.dataCorsi.langs = null;
      if (this.dataCorsi.field_lingua && this.dataCorsi.field_lingua.length) {
        for (const lang of this.dataCorsi.field_lingua) {
          let langCode = "";
          switch (lang) {
            case "Italiano":  langCode = "IT"; break;
            case "Inglese":  langCode = "EN"; break;
          }
          if (langCode) {
            if (!this.dataCorsi.langs) {
              this.dataCorsi.langs = langCode;
            } else {
              this.dataCorsi.langs = `${this.dataCorsi.langs}/${langCode}`;
            }
          }
        }
      }
    }
  }

  private setLabelTags() {
    let taxonomies: string[] = [];
    if (this.dataCorsi.field_tassonomia_area_universita) {
      this.dataCorsi.field_tassonomia_area_universita.forEach((taxonomy: any, idx: number) => {
        if (idx < 3) {
          taxonomies.push(taxonomy.name);
        }
      });
      if (this.dataCorsi.field_tassonomia_area_universita.length > 3) {
        taxonomies.push(`+${this.dataCorsi.field_tassonomia_area_universita.length - 3}`)
      }
    }
    this.stringTaxonomies = taxonomies.join(', ');
  }

}
